import React, { useEffect, useState } from 'react';
import {
  CompanySize,
  CompanyType,
  HierarchicalLevel,
  Industry,
  ProfessionalSituation,
  useCurrentParticipant,
  useUpdateParticipant,
} from '@app/api';
import { Formik, FormikHelpers } from 'formik';
import { InformationPaneLayout } from './components/InformationPaneLayout';
import { useToast } from '@app/core';
import { Professional } from '../components/ProfileFields';

interface Props {
  icon: string;
  title: string;
}

interface Values {
  id: string;
  professionalSituation: ProfessionalSituation;
  jobTitle?: string | null;
  hierarchicalLevel?: HierarchicalLevel | null;
  industries: Industry[] | null;
  companySize?: CompanySize | null;
  companyType?: CompanyType | null;
  linkedinProfileUrl?: string | null;
}

export const ProfessionalProfile = ({ icon, title }: Props) => {
  const toast = useToast();

  const { data: participant, isLoading: isParticipantLoading } =
    useCurrentParticipant();

  const { mutateAsync: updateParticipant } = useUpdateParticipant(
    participant?.id,
  );
  const submit = async (
    values: Values,
    { setValues }: FormikHelpers<Values>,
  ) => {
    try {
      let newValues = values;
      if (
        values.professionalSituation === ProfessionalSituation.STUDENT &&
        values.jobTitle === null
      ) {
        newValues = {
          ...values,
          jobTitle: null,
          companySize: null,
          companyType: null,
          hierarchicalLevel: null,
          industries: null,
        };
      }
      const p = await updateParticipant(newValues);
      setValues(p);
      toast.saved();
    } catch (e) {
      toast.exception(e);
      throw e;
    }
  };

  if (!participant) {
    return null;
  }

  return (
    <Formik onSubmit={submit} initialValues={participant as Values}>
      <InformationPaneLayout icon={icon} title={title}>
        <Professional noTitle />
      </InformationPaneLayout>
    </Formik>
  );
};
